import { useMemo } from 'react';
import { Flex, OverflowTooltip } from '@elementary/common-ui/components';
import StatusChip, {
  ChipStatus,
} from '@elementary/common-ui/components/Chip/StatusChip';
import { localizeDate } from '@elementary/common-ui/utils/datetime';
import { Typography } from '@mui/material';

const LastModelRunState = ({
  time,
  size,
  status,
  showOnlyTime,
  showOnlyStatus,
}: {
  time?: string;
  size?: 'small' | 'medium';
  status?: ChipStatus;
  showOnlyTime?: boolean;
  showOnlyStatus?: boolean;
}) => {
  const textColor = useMemo(() => {
    if (status === 'success' || status === 'pass') {
      return 'common.green100';
    }
    if (status === 'error' || status === 'fail') {
      return 'common.red100';
    }
    if (status === 'warning' || status === 'warn') {
      return 'common.orange';
    }
    return 'common.gray2';
  }, [status]);

  if (!showOnlyStatus && (showOnlyTime ? !time : !time || !status)) {
    return <Typography>{showOnlyTime ? '-' : 'N/A'}</Typography>;
  }

  if (showOnlyStatus) {
    return status ? (
      <StatusChip status={status} size={size} />
    ) : (
      <Typography>-</Typography>
    );
  }

  return (
    <Flex alignItems="center" gap={1} sx={{ flexWrap: 'wrap' }}>
      <OverflowTooltip color={textColor} sx={{ width: 'auto !important' }}>
        {localizeDate(time).format('L LT')}
      </OverflowTooltip>

      {!showOnlyTime && !!status && <StatusChip status={status} size={size} />}
    </Flex>
  );
};

export default LastModelRunState;
